// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import _engine from "@/core/engine";
import { AppEngine } from "@shared/types/localtypes.ts";
export const engine: AppEngine = _engine;
